/* eslint-disable @nx/enforce-module-boundaries */
import { Component, computed, input } from "@angular/core";
import { Icon } from "../../icon/icon.component";
import { ActionSheetOption } from "../action-sheet.type";

@Component({
    selector: "app-action-sheet-multiple-option",
    templateUrl: "./action-sheet-multiple-option.component.html",
    imports: [Icon],
})
export class ActionSheetMultipleOptionComponent {
    label = computed(() => this.option().label);
    value = computed(() => this.option().value);
    active = computed(() => this.currentValue()?.includes?.(this.value()));

    option = input.required<ActionSheetOption>();
    currentValue = input<any[]>();
}
